import type { ReactNode } from "react";

import { Toast as BaseUIToast } from "@base-ui/react/toast";

import { toAddOptions } from "./toast.helper";
import type { ToastOptions, ToastType } from "./toast.type";

const toastManager = BaseUIToast.createToastManager();

const notify =
  (type: ToastType) =>
  (message: ReactNode, options: ToastOptions = {}): string =>
    toastManager.add({ ...toAddOptions(options), type, description: message });

const toast = {
  success: notify("success"),
  error: notify("error"),
  info: notify("info"),
  warning: notify("warning"),
  loading: notify("loading"),
  dismiss: (id?: string) => toastManager.close(id),
};

export { toast, toastManager };
